/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPennant = createReactComponent("outline", "pennant", "IconPennant", [["path", { "d": "M8 21l4 0", "key": "svg-0" }], ["path", { "d": "M10 21l0 -18", "key": "svg-1" }], ["path", { "d": "M10 4l9 4l-9 4", "key": "svg-2" }]]);

export { IconPennant as default };
//# sourceMappingURL=IconPennant.mjs.map
